import React from 'react';

const BoldPar = ({paragraphContent}) => (
    <>
        <p className="bold_article_paragraph">{paragraphContent}</p>
    </>
);

export default BoldPar;